<template>
    <div v-if="event.persons">
        <div v-for="person in event.persons" :key="person.id" class="card overflow-hidden">
            <!-- Card body -->
            <div class="row align-items-start align-items-lg-stretch">
                <div v-if="person.image" class="col-sm-5 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
                    <!-- Avatar -->
                    <img
                        :alt="$t('iFrame.imageOf') + ' ' + person.name"
                        :src="person.image" class="image">
                    <image-licence v-if="person.imageLicence" :licence="person.imageLicence"/>
                </div>
                <div class="col">
                    <div class="m-3">
                        <h2>
                            {{ person.name }}
                        </h2>
                        <secure-html v-if="!!person.biography" class="biography" :html="person.biography"></secure-html>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "EventEntryTeam",
    props: {
        event: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.image {
    min-height: 185px;
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.biography p {
    font-size: 0.9rem;
}
</style>
